export const APP_FEEDBACK_SOURCE_OPTIONS = [
  { value: "", label: "All areas" },
  { value: "wizard", label: "AI Chat / Matching" },
  { value: "search", label: "Search" },
  { value: "category", label: "Category browse" },
  { value: "compare", label: "Compare" },
  { value: "product", label: "Product page" },
  { value: "feed", label: "Feed" },
  { value: "marketplace", label: "Marketplace" },
  { value: "profile", label: "Profile" },
  { value: "account_deletion", label: "Account deletion" },
  { value: "other", label: "Other" },
];

export const ACCOUNT_DELETION_REASON_OPTIONS = [
  { value: "missing_features", label: "Missing features I need" },
  { value: "too_hard_to_use", label: "Too hard to use" },
  { value: "found_alternative", label: "Found a better alternative" },
  { value: "privacy_concerns", label: "Privacy concerns" },
  { value: "not_useful", label: "Not useful for me" },
  { value: "too_many_emails", label: "Too many emails or notifications" },
  { value: "other", label: "Other" },
];

export const APP_FEEDBACK_SOURCE_LABELS = APP_FEEDBACK_SOURCE_OPTIONS.reduce(
  (acc, option) => {
    if (option.value) acc[option.value] = option.label;
    return acc;
  },
  {},
);

export const getAppFeedbackSourceLabel = (source) =>
  APP_FEEDBACK_SOURCE_LABELS[source] || source || "Unknown";
